import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";


@Component({
  selector: "si-keycloak-sso",
  templateUrl: "./si-keycloak-sso.component.html",
  styleUrls: ["./si-keycloak-sso.component.scss"],
})
export class SiKeyCloakSSOComponent implements OnInit {

  constructor(public router : Router) {
    this.router.onSameUrlNavigation = 'reload';
    this.initialize();
  }

  ngOnInit() { }
  
  private initialize() {
    this.router.navigate(['/kcloginredirect'], { queryParams: {redirects : true, status : 'prelogin'}});
  }
}
